import React from 'react'
import { Panel, Row, Col } from 'rsuite'

export default function ProjectInfoView(props) {
  const noData = '- ไม่พบข้อมูล -'
  const { schema } = props
  return (
    <>
      {schema && (
        <Panel bordered>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 10 }}>
              <span>
                <b>{schema.header}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <span>
                {schema.projectName.label} : <b>{schema.projectName.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <span>
                {schema.projectCode.label} : <b>{schema.projectCode.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <span>
                {schema.projectType.label} : <b>{schema.projectType.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <span>
                {schema.projectProposalType.label} :{' '}
                <b>{schema.projectProposalType.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <span>
                {schema.projectStatus.label} : <b>{schema.projectStatus.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <span>
                {schema.ownerName.label} : <b>{schema.ownerName.value || noData}</b>
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <span>
                {schema.coordinatorName.label} : <b>{schema.coordinatorName.value || noData}</b>
              </span>
            </Col>
          </Row>
        </Panel>
      )}
    </>
  )
}
